export default __webpack_public_path__ + "static/media/boss-right2.fd2bbd77.png";